import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Play, X } from 'lucide-react';

interface InstructionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const InstructionsModal: React.FC<InstructionsModalProps> = ({ isOpen, onClose }) => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-slate-50 via-blue-50/30 to-purple-50/30 z-50">
      <div className="h-full flex flex-col">
        {/* Header with close button */}
        <div className="flex-shrink-0 flex items-center justify-between p-6 border-b border-slate-200">
          <h1 className="text-2xl font-bold text-slate-800">How to Play</h1>
          <motion.button
            onClick={onClose}
            className="p-2 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <X size={24} />
          </motion.button>
        </div>

        {/* Content */}
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="max-w-md w-full space-y-6 text-slate-600">
            <div className="space-y-4">
              <p className="text-lg">
                🎯 <strong>Connect the words</strong> by drawing lines between them.
              </p>
              <p className="text-lg">
                🔗 <strong>Each word connects to two others</strong> as synonyms, forming a circle.
              </p>
              <p className="text-lg">
                ❌ <strong>You can make three errors</strong> — each error adds a circle to the center.
              </p>
              <p className="text-lg">
                🎲 <strong>On the fourth error</strong>, the solution will be revealed.
              </p>
            </div>
            
            <div className="pt-6 border-t border-slate-200">
              <p className="text-base text-slate-500 mb-6 text-center">
                Good luck and have fun! 🌟
              </p>
              
              <motion.button
                onClick={onClose}
                className="w-full bg-blue-600 text-white py-4 px-6 rounded-xl font-semibold flex items-center justify-center gap-2 hover:bg-blue-700 transition-colors"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Play size={20} />
                Start Game
              </motion.button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructionsModal;